import React from "react";
import styled, { css, keyframes } from "styled-components";
const TOTAL_FRAMES = 65;
const FPS = 60;
const DURATION = TOTAL_FRAMES / FPS; // 1.08333s

const pct = (frame: number) => `${(frame / TOTAL_FRAMES) * 100}%`;
const makeDotKeyframes = (startFrame: number) => keyframes`
  /* 루프 시작: 회색(리셋 상태) */
  0% {
    transform: translateY(0);
    background-color: #D9D9D9;
  }

  /* 시작 전까지는 회색/바닥 유지 */
  ${pct(startFrame)} {
    transform: translateY(0);
    background-color: #D9D9D9;
  }

  /* start+8f: 최고점 + 주황 */
  ${pct(startFrame + 8)} {
    transform: translateY(-1.2rem);
    background-color: #FF9800;
  }

  /* start+15f: 바닥 복귀 + 주황 */
  ${pct(startFrame + 15)} {
    transform: translateY(0);
    background-color: #FF9800;
  }

  /* 100%까지 주황 유지(홀드) */
  100% {
    transform: translateY(0);
    background-color: #FF9800;
  }
`;
const LoadingContainer = styled.div`
  width: 100dvw;
  height: 100dvh;
  display: flex;
  gap: 0.8rem;
  justify-content: center;
  align-items: center;
`;

const Dot = styled.div<{ startFrame: number }>`
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 9999px;
  will-change: transform;

  ${({ startFrame }) => css`
    animation: ${makeDotKeyframes(startFrame)} ${DURATION}s linear infinite;
  `}
`;

export default function Loading() {
  return (
    <LoadingContainer>
      <Dot startFrame={0} />
      <Dot startFrame={10} />
      <Dot startFrame={20} />
    </LoadingContainer>
  );
}
